import React, { createContext, useState, useEffect } from "react";
import api from "../apis/api"; // Az Axios példány importálása, amely kezeli a JWT tokent

export const SzakokContext = createContext();

export const SzakokContextProvider = (props) => {
    const [szakok, setSzakok] = useState([]);
    const [selectedSzak, setSelectedSzak] = useState(null);
    const [szakfelelosok, setSzakfelelosok] = useState([]);
    const [selectedSzakfelelos, setSelectedSzakfelelos] = useState(null);

    const fetchSzakok = async () => {
        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                console.log("No token available, skipping szakok fetch");
                return;
            }
            
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await api.get("/szakok");
            setSzakok(response.data.data.szakok);
        } catch (err) {
            console.error("Error fetching szakok:", err);
        }
    };

    const fetchSzakfelelosok = async () => {
        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                console.log("No token available, skipping szakfelelosok fetch");
                return;
            }
            
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await api.get("/szakfelelosok");
            setSzakfelelosok(response.data.data.szakfelelosok);
        } catch (err) {
            console.error("Error fetching szakfelelosok:", err);
        }
    };

    // Function to refetch all data (can be called after login)
    const refetchData = () => {
        fetchSzakok();
        fetchSzakfelelosok();
    };

    useEffect(() => {
        // Only fetch data if we have a token
        const token = localStorage.getItem('access_token');
        if (token) {
            fetchSzakok();
            fetchSzakfelelosok();
        }
    }, []);

    return (
        <SzakokContext.Provider value={{
            szakok,
            setSzakok,
            selectedSzak,
            setSelectedSzak,
            szakfelelosok,
            setSzakfelelosok,
            selectedSzakfelelos,
            setSelectedSzakfelelos,
            refetchData
        }}>
            {props.children}
        </SzakokContext.Provider>
    );
};
